export default "__VITE_ASSET__BHigrdw$__"